﻿import { createFileRoute } from "@tanstack/react-router";
import { ontemISO, ConsumoMaterialPage } from "@/paginas/pg_insumos/insumos-consumo";

export const Route = createFileRoute("/_authenticated/insumos-consumo")({
  validateSearch: (s: Record<string, unknown>) => ({
    data: typeof s["data"] === "string" && s["data"] ? (s["data"] as string) : ontemISO(),
  }),
  head: () => ({
    meta: [
      { title: "Consumo de material — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Veja o consumo de insumos de cada produto vendido na data escolhida e o total consolidado.",
      },
      { property: "og:title", content: "Consumo de material — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Veja o consumo de insumos de cada produto vendido na data escolhida e o total consolidado.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ConsumoMaterialPage,
});
